"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentlySoldTransaction$ = exports.RecentlySoldTransaction$outboundSchema = exports.RecentlySoldTransaction$inboundSchema = void 0;
exports.recentlySoldTransactionToJSON = recentlySoldTransactionToJSON;
exports.recentlySoldTransactionFromJSON = recentlySoldTransactionFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const addresses_js_1 = require("./addresses.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const propertytype_js_1 = require("./propertytype.js");
/** @internal */
exports.RecentlySoldTransaction$inboundSchema = z.object({
    address: addresses_js_1.Addresses$inboundSchema,
    distance_in_metres: z.nullable(z.number().int()),
    internal_area_square_metres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    price: z.number().int(),
    price_per_square_metre: z.nullable(z.number().int()),
    property_type: z.nullable(propertytype_js_1.PropertyType$inboundSchema),
    street_group_property_id: z.string(),
    transaction_date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
        "internal_area_square_metres": "internalAreaSquareMetres",
        "price_per_square_metre": "pricePerSquareMetre",
        "property_type": "propertyType",
        "street_group_property_id": "streetGroupPropertyId",
        "transaction_date": "transactionDate",
    });
});
/** @internal */
exports.RecentlySoldTransaction$outboundSchema = z.object({
    address: addresses_js_1.Addresses$outboundSchema,
    distanceInMetres: z.nullable(z.number().int()),
    internalAreaSquareMetres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    price: z.number().int(),
    pricePerSquareMetre: z.nullable(z.number().int()),
    propertyType: z.nullable(propertytype_js_1.PropertyType$outboundSchema),
    streetGroupPropertyId: z.string(),
    transactionDate: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
        internalAreaSquareMetres: "internal_area_square_metres",
        pricePerSquareMetre: "price_per_square_metre",
        propertyType: "property_type",
        streetGroupPropertyId: "street_group_property_id",
        transactionDate: "transaction_date",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RecentlySoldTransaction$;
(function (RecentlySoldTransaction$) {
    /** @deprecated use `RecentlySoldTransaction$inboundSchema` instead. */
    RecentlySoldTransaction$.inboundSchema = exports.RecentlySoldTransaction$inboundSchema;
    /** @deprecated use `RecentlySoldTransaction$outboundSchema` instead. */
    RecentlySoldTransaction$.outboundSchema = exports.RecentlySoldTransaction$outboundSchema;
})(RecentlySoldTransaction$ || (exports.RecentlySoldTransaction$ = RecentlySoldTransaction$ = {}));
function recentlySoldTransactionToJSON(recentlySoldTransaction) {
    return JSON.stringify(exports.RecentlySoldTransaction$outboundSchema.parse(recentlySoldTransaction));
}
function recentlySoldTransactionFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RecentlySoldTransaction$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RecentlySoldTransaction' from JSON`);
}
//# sourceMappingURL=recentlysoldtransaction.js.map